import digitalData from 'digital-data';
import {
  OVERLAY,
  SELECT_PROJECT_ADD_TO,
  SELECT_PROJECT_SUFFIX,
  EVENT_NAME_PREFIX_PROJECTS,
  STASH,
  MY_ACCOUNT_SETTINGS,
  BUTTON_SUBMISSION,
  INTERACTION,
  CREATE_LIST,
  ADD_TO_MOBILE,
  ADD_TO_PREFIX,
  ADD_TO_SCREEN
} from '../constants';
import { getPageType } from '../thd-analytics-utils';

export const addTo = () => {
  // 7.51.2 Create New Project button click
  LIFE_CYCLE_EVENT_BUS.on(SELECT_PROJECT_ADD_TO, () => {
    const page = getPageType();
    const newPage = EVENT_NAME_PREFIX_PROJECTS[page] ?? page;
    const currentEventName = `${newPage}${SELECT_PROJECT_SUFFIX}`;
    const ddoEvent = {
      category: {
        primaryCategory: OVERLAY
      },
      eventInfo: {
        eventName: currentEventName
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

  LIFE_CYCLE_EVENT_BUS.on('add-to.addTo', () => {
    const ddoEvent = {
      category: {
        primaryCategory: OVERLAY
      },
      eventInfo: {
        eventName: 'add to'
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

  // 6.4 Add Materials/Start Shopping Buttons
  window.LIFE_CYCLE_EVENT_BUS.on('add-to.addToMaterials', ({ output }) => {
    const buttonType = output?.buttonType || '';
    const ddoEvent = {
      category: {
        primaryCategory: STASH
      },
      eventInfo: {
        eventName: MY_ACCOUNT_SETTINGS
      },
      eventMode: STASH,
      stash: {
        myAccount: {
          settings: `lists: ${buttonType}`
        }
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

  // 6.6 Add to List Overlay (Mini PLP)
  window.LIFE_CYCLE_EVENT_BUS.on('add-to.addToMaterialsOverlay', ({ output }) => {
    const addType = output?.addType || '';
    const ddoEvent = {
      category: {
        primaryCategory: OVERLAY
      },
      eventInfo: {
        eventName: `add to ${addType}`
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

  // 6.9.2 New List Created w/Product Add
  window.LIFE_CYCLE_EVENT_BUS.on('add-to.newListCreatedProductAdded', ({ output }) => {
    const { location, items } = output || {};
    const itemsFormatted = items.map((item) => ({
      quantity: item.quantity,
      listLocation: location,
      price: {
        basePrice: item.price * item.quantity
      },
      productInfo: {
        sku: item.sku
      }
    }));
    const ddoEvent = {
      category: {
        primaryCategory: INTERACTION
      },
      eventInfo: {
        eventName: CREATE_LIST
      },
      myList: {
        creationLoction: location
      },
      item: itemsFormatted
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

  // 6.12.1 Add to List Action
  window.LIFE_CYCLE_EVENT_BUS.on('add-to.addToAction', ({ output }) => {
    const { name, location, items, isBulkAction } = output;
    const itemsFormatted = items.map((item) => ({
      quantity: item.quantity,
      listLocation: location,
      price: {
        basePrice: item.price * item.quantity
      },
      productInfo: {
        sku: item.sku
      }
    }));
    const ddoEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: name
      },
      bulkAction: isBulkAction,
      item: itemsFormatted
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

  // 6.6.1 Mini PLP Search
  window.LIFE_CYCLE_EVENT_BUS.on('add-to.miniPLPSearch', ({ output }) => {
    const searchTerm = output?.searchTerm || '';
    const ddoEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: 'mini plp search'
      },
      miniPLPSearchTerm: searchTerm
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

  // 6.6.3 Add to List/Add Items to List Overlay: Back/X/OK/Close
  window.LIFE_CYCLE_EVENT_BUS.on('add-to.addToOverlayClose', ({ output }) => {
    const actionType = output?.actionType || '';
    const ddoEvent = {
      category: {
        primaryCategory: OVERLAY
      },
      eventInfo: {
        eventName: actionType || 'add to overlay close'
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

  // 6.7 Add Items to List Overlay (Mini PIP)
  window.LIFE_CYCLE_EVENT_BUS.on('add-to.addToSearchPipView', ({ output }) => {
    const addToType = output?.addToType || '';
    const ddoEvent = {
      category: {
        primaryCategory: OVERLAY
      },
      eventInfo: {
        eventName: `add items to ${addToType}`
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

  LIFE_CYCLE_EVENT_BUS.on(ADD_TO_MOBILE, () => {
    const ddoEvent = {
      category: {
        primaryCategory: OVERLAY
      },
      eventInfo: {
        eventName: 'add to'
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

  // 7.1 Copy from Your Lists selection
  window.LIFE_CYCLE_EVENT_BUS.on('add-to.copyFromYourListsSelection', () => {
    const ddoEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: MY_ACCOUNT_SETTINGS
      },
      myAccount: {
        settings: 'lists: list creation: add materials overlay: copy from your lists'
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

  // 7.3 Copy from Your Lists Exit Overlay
  window.LIFE_CYCLE_EVENT_BUS.on('add-to.copyFromYourListsExitOverlay', () => {
    const ddoEvent = {
      category: {
        primaryCategory: OVERLAY
      },
      eventInfo: {
        eventName: 'copy from your lists: exit confirmation'
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

  // 7.4 Copy from Your Lists Exit Overlay: Discard and Exit/Cancel
  window.LIFE_CYCLE_EVENT_BUS.on('add-to.copyFromYourListsExitAction', ({ output }) => {
    const actionType = output?.actionType || ''; // 'discard and exit button' or 'cancel button'
    const ddoEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: MY_ACCOUNT_SETTINGS
      },
      myAccount: {
        settings: `lists: copy from your lists exit overlay: ${actionType}`
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

  // 7.5 Mini List Details Overlay
  window.LIFE_CYCLE_EVENT_BUS.on('add-to.miniListDetailsOverlay', () => {
    const ddoEvent = {
      category: {
        primaryCategory: OVERLAY
      },
      eventInfo: {
        eventName: 'mini list details'
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

  // 6.13.1 Add to List action
  window.LIFE_CYCLE_EVENT_BUS.on('add-to.listAddAction', ({ output }) => {
    const { location, items, isBulkAction } = output || {};
    
    // Return early if required data is missing
    if (!items || !Array.isArray(items)) {
      return;
    }
    
    const page = getPageType();
    const isUnknownPage = !page || page === 'unknown';
    
    // Determine final location string
    let listLocation;
    if (location === 'lists: shared list') {
      // Keep shared list location as-is
      listLocation = location;
    } else if (isUnknownPage) {
      // No prefix for unknown pages, just use screen mapping or location as-is
      listLocation = ADD_TO_SCREEN[location] || location;
    } else {
      // Use page prefix if available, otherwise fall back to page type
      const prefix = ADD_TO_PREFIX[page] || page;
      const screenLocation = ADD_TO_SCREEN[location] || location;
      listLocation = `${prefix}: ${screenLocation}`;
    }

    const itemsFormatted = items.map((item) => ({
      quantity: item.quantity,
      listLocation,
      price: {
        basePrice: item.price * item.quantity
      },
      productInfo: {
        sku: item.sku
      }
    }));
    const ddoEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: 'list add'
      },
      bulkAction: isBulkAction,
      item: itemsFormatted
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

  // 7.51.59 Select List, Project Overlays
  window.LIFE_CYCLE_EVENT_BUS.on('add-to.copyToSelectListOrProjectOverlays', ({ output }) => {
    const { selectionType } = output || {};
    const ddoEvent = {
      category: {
        primaryCategory: OVERLAY
      },
      eventInfo: {
        eventName: `select ${selectionType}`
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

  // 7.6 Mini List Details Overlay: Back button
  window.LIFE_CYCLE_EVENT_BUS.on('add-to.miniListDetailsBackButton', () => {
    const ddoEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: MY_ACCOUNT_SETTINGS
      },
      myAccount: {
        settings: 'lists: mini list details overlay: back button'
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

  // 7.7 Mini List Details Exit Overlay
  window.LIFE_CYCLE_EVENT_BUS.on('add-to.miniListDetailsExitOverlay', () => {
    const ddoEvent = {
      category: {
        primaryCategory: OVERLAY
      },
      eventInfo: {
        eventName: 'mini list details: exit confirmation'
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

  // 7.8 Mini List Details Exit Overlay: Discard and Exit/Cancel
  window.LIFE_CYCLE_EVENT_BUS.on('add-to.miniListDetailsExitAction', ({ output }) => {
    const actionType = output?.actionType || ''; // 'discard and exit button' or 'cancel button'
    const ddoEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: MY_ACCOUNT_SETTINGS
      },
      myAccount: {
        settings: `lists: mini list details exit overlay: ${actionType}`
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });
};
